import React from 'react';
import { Truck, Package, Zap, Lock, CreditCard } from 'lucide-react';
import { motion } from 'framer-motion';
export function Pricing() {
  return <section id="bundles" className="bg-offwhite py-16 md:py-24 px-5 scroll-mt-20" data-id="element-419">
      <div className="max-w-[900px] mx-auto" data-id="element-420">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16" data-id="element-421">
          <h2 className="font-playfair text-[28px] md:text-[36px] text-ink font-semibold mb-4" data-id="element-422">
            Choose Your DryControl™ Bundle
          </h2>
          <p className="font-inter text-[16px] text-secondary" data-id="element-423">
            All orders include free UK delivery. 90-day money-back guarantee on
            every order.
          </p>
        </div>

        {/* Pricing Cards */}
        <div className="flex flex-col md:flex-row gap-6 md:gap-4 lg:gap-6 items-center md:items-stretch justify-center mb-12" data-id="element-424">
          {/* Mobile Order: Card 2 (Most Popular) goes first, so we use flex order on mobile */}

          {/* Card 1: Starter */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="order-2 md:order-1 w-full max-w-[340px] md:w-1/3 bg-white border border-divider rounded-xl p-6 md:p-7 flex flex-col shadow-subtle" data-id="element-425">
            <div className="h-[160px] flex items-center justify-center mb-4 -mx-2" data-id="element-426">
              <img src="https://cdn.magicpatterns.com/uploads/cqLYXmHFTSdGxgfUdcp3E5/Your_paragraph_text_(26).png" alt="DryControl 1 Box Starter Pack" className="max-h-full max-w-full object-contain" data-id="element-427" />
            </div>
            <div className="font-inter text-[12px] uppercase text-secondary mb-2" data-id="element-428">
              Starter
            </div>
            <div className="font-playfair text-[24px] text-ink mb-4" data-id="element-429">1 Box</div>
            <div className="flex items-end gap-2 mb-1" data-id="element-430">
              <div className="font-inter font-bold text-[32px] text-ink leading-none" data-id="element-431">
                £24.95
              </div>
              <div className="font-inter text-[16px] text-secondary line-through mb-1" data-id="element-432">
                £50
              </div>
            </div>
            <div className="mb-6" data-id="element-433">
              <span className="inline-block border border-forest text-forest font-inter text-[12px] rounded-full px-3 py-1" data-id="element-434">
                90-day guarantee
              </span>
            </div>

            <div className="mt-auto" data-id="element-435">
              <button onClick={() => window.location.href = 'https://glowliftessence.com/cart/46854801064126:1'} className="w-full h-[48px] border-2 border-forest text-forest font-inter font-semibold text-[15px] rounded-lg hover:bg-forest hover:text-white transition-colors" data-id="element-436">
                Order now
              </button>
            </div>
          </motion.div>

          {/* Card 2: Most Popular */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="order-1 md:order-2 w-full max-w-[340px] md:w-1/3 bg-forest rounded-xl p-6 md:p-7 flex flex-col shadow-subtle relative md:-translate-y-2 z-10" data-id="element-437">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-gold text-white font-inter font-semibold text-[12px] rounded-full px-4 py-1 whitespace-nowrap" data-id="element-438">
              Most Popular
            </div>

            <div className="h-[160px] flex items-center justify-center mb-4 bg-white rounded-lg -mx-2 px-2" data-id="element-439">
              <img src="https://cdn.magicpatterns.com/uploads/oJHXzjCtseJDB2mosCfLAM/Your_paragraph_text_(25).png" alt="DryControl Buy 2 Get 2 Free Bundle" className="max-h-full max-w-full object-contain" data-id="element-440" />
            </div>

            <div className="font-inter text-[12px] uppercase text-white/70 mb-2" data-id="element-441">
              Best Value
            </div>
            <div className="font-playfair text-[24px] text-white mb-4" data-id="element-442">
              2 Boxes + 2 Free
            </div>

            <div className="flex items-end gap-2 mb-1" data-id="element-443">
              <div className="font-inter font-bold text-[36px] text-white leading-none" data-id="element-444">
                £49.95
              </div>
              <div className="font-inter text-[16px] text-white/60 line-through mb-1" data-id="element-445">
                £100
              </div>
            </div>

            <div className="font-inter text-[13px] text-gold mb-6 h-[20px]" data-id="element-446">
              £12.49 per box — save 50%
            </div>

            <div className="mb-6" data-id="element-447">
              <span className="inline-block bg-white text-forest font-inter font-semibold text-[12px] rounded-full px-3 py-1" data-id="element-448">
                90-day guarantee
              </span>
            </div>

            <div className="mt-auto" data-id="element-449">
              <button onClick={() => window.location.href = 'https://glowliftessence.com/cart/46854801096894:1'} className="w-full h-[52px] bg-white text-forest font-inter font-semibold text-[16px] rounded-lg hover:bg-offwhite transition-colors shadow-subtle" data-id="element-450">
                Order now
              </button>
            </div>
          </motion.div>

          {/* Card 3: Buy 3 Get 3 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="order-3 md:order-3 w-full max-w-[340px] md:w-1/3 bg-white border-2 border-gold rounded-xl p-6 md:p-7 flex flex-col shadow-subtle" data-id="element-451">
            <div className="h-[160px] flex items-center justify-center mb-4 -mx-2" data-id="element-452">
              <img src="https://cdn.magicpatterns.com/uploads/mBX4b4mejs3hEGc7fqGuGb/Your_paragraph_text_(24).png" alt="DryControl Buy 3 Get 3 Free Bundle" className="max-h-full max-w-full object-contain" data-id="element-453" />
            </div>
            <div className="font-inter text-[12px] uppercase text-gold mb-2 font-semibold" data-id="element-454">
              Best Value
            </div>
            <div className="font-playfair text-[24px] text-ink mb-4" data-id="element-455">
              3 Boxes + 3 Free
            </div>

            <div className="flex items-end gap-2 mb-1" data-id="element-456">
              <div className="font-inter font-bold text-[32px] text-ink leading-none" data-id="element-457">
                £74.95
              </div>
              <div className="font-inter text-[16px] text-secondary line-through mb-1" data-id="element-458">
                £150
              </div>
            </div>

            <div className="font-inter text-[13px] text-secondary mb-6 h-[20px]" data-id="element-459">
              £12.49 per box
            </div>

            <div className="mb-6" data-id="element-460">
              <span className="inline-block bg-forest text-white font-inter text-[12px] rounded-full px-3 py-1" data-id="element-461">
                90-day guarantee
              </span>
            </div>

            <div className="mt-auto" data-id="element-462">
              <button onClick={() => window.location.href = 'https://glowliftessence.com/cart/46854801064126:1'} className="w-full h-[48px] bg-forest text-white font-inter font-semibold text-[15px] rounded-lg hover:bg-forest/90 transition-colors" data-id="element-463">
                Order now
              </button>
            </div>
          </motion.div>
        </div>

        {/* Trust Signals */}
        <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 font-inter text-[13px] text-secondary" data-id="element-464">
          <span className="flex items-center" data-id="element-465">
            <Truck className="w-4 h-4 mr-1.5" data-id="element-466" /> Free UK delivery
          </span>
          <span className="flex items-center" data-id="element-467">
            <Package className="w-4 h-4 mr-1.5" data-id="element-468" /> Discreet packaging
          </span>
          <span className="flex items-center" data-id="element-469">
            <Zap className="w-4 h-4 mr-1.5" data-id="element-470" /> Ships within 24 hours
          </span>
          <span className="flex items-center" data-id="element-471">
            <Lock className="w-4 h-4 mr-1.5" data-id="element-472" /> Secure checkout
          </span>
          <span className="flex items-center" data-id="element-473">
            <CreditCard className="w-4 h-4 mr-1.5" data-id="element-474" /> Card, PayPal, Apple Pay
          </span>
        </div>
      </div>
    </section>;
}